<template>
  <button
    type="button"
    class="btn-gradient p-3 rounded-sm relative text-button1 font-semibold text-white w-full cursor-pointer"
    :class="{ 'text-white/40': disabled }"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  disabled?: boolean;
}>();
</script>
